<template>
  <div id="app" :class="{'wb-ba': $i18n.locale == 'zh-CN', 'isPc': !isMobile}">
    <div class="appContent">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
  import i18next from 'i18next';
  export default {
    name: 'App',
    data() {
      return {
        isMobile: true
      }
    },
    created() {
      this.isMobile = this.$utils.isMobile();
      this.setLanguage();
    },
    mounted() {
      this.bus.mergeLang("login")
    },
    methods: {
      /**
       * 设置语言
       */
      setLanguage() {
        var language = localStorage.getItem("language");
        if (language) {
          var language = this.$utils.getDefaultLanguage(language);
          this.$i18n.locale = language;
          i18next.changeLanguage(language);
        } else {
          var language = this.$utils.getDefaultLanguage();
          this.$i18n.locale = language;
          i18next.changeLanguage(language);
        }
        localStorage.setItem("language", language);
      },
    }
  }
</script>

<style lang="scss">
  * {
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0) !important;
    margin: 0;
    padding: 0;
    font-family: "微软雅黑";
  }

  body {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0 !important;
    font-weight: 400 !important;
    overflow: hidden;
  }

  img {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }

  #app {
    height: 100%;

    .appContent {
      width: 100%;
      height: 100%;
      position: relative;
    }

    &.isPc {
      background-color: #f2f5fa;

      .appContent {
        width: 500px;
        margin: 0 auto;
        border-right: 1px solid #dedede;
        border-left: 1px solid #dedede;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue